import { Globe, Mail, Phone, MapPin } from "lucide-react";
import { LOGO, FOOTER } from "@/data";

export const Footer = () => (
  <footer id="kontakt" className="bg-[var(--forest)] text-white">
    <div className="mx-auto max-w-6xl px-6 py-16">
      <div className="grid gap-12 md:grid-cols-2">
        <div>
          <div className="inline-flex rounded-2xl bg-white px-4 py-3">
            <img src={LOGO} alt="AGE Centrum" className="h-12 w-auto" />
          </div>
          <p className="mt-6 font-display text-2xl font-semibold">
            {FOOTER.tagline}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2 md:justify-items-end md:self-center">
          <a
            href={`https://${FOOTER.website}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-website"
            className="flex items-center gap-3 text-sm text-white/85 hover:text-white transition-colors"
          >
            <Globe className="h-4 w-4 text-[var(--lime)]" /> {FOOTER.website}
          </a>
          <a
            href={`mailto:${FOOTER.email}`}
            data-testid="footer-email"
            className="flex items-center gap-3 text-sm text-white/85 hover:text-white transition-colors"
          >
            <Mail className="h-4 w-4 text-[var(--lime)]" /> {FOOTER.email}
          </a>
          <a
            href={`tel:${FOOTER.phone.replace(/\s/g, "")}`}
            data-testid="footer-phone"
            className="flex items-center gap-3 text-sm text-white/85 hover:text-white transition-colors"
          >
            <Phone className="h-4 w-4 text-[var(--lime)]" /> {FOOTER.phone}
          </a>
          <span className="flex items-center gap-3 text-sm text-white/85">
            <MapPin className="h-4 w-4 text-[var(--lime)]" /> {FOOTER.address}
          </span>
        </div>
      </div>

      <div
        data-testid="footer-partners"
        className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-6"
      >
        <img
          src="/images/logo-olomouc.png"
          alt="Statutární město Olomouc"
          className="h-9 w-auto object-contain"
        />
        <img
          src="/images/logo-pikola.png"
          alt="Pikola"
          className="h-7 w-auto object-contain brightness-0 invert"
        />
        <img
          src="/images/logo-mujlekarnik.png"
          alt="mujlekarnik.cz"
          className="h-9 w-auto object-contain brightness-0 invert"
        />
      </div>

      <div className="mt-10 border-t border-white/15 pt-6">
        <p className="text-sm text-white/65">{FOOTER.copyright}</p>
      </div>
    </div>
  </footer>
);
